// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__ol2AI","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__35PJF"};